import React from "react";
import { useAuth } from "provider/AuthContext";
import { formatToTwoDecimalPlaces } from "helper/Functions";

const CasinoBonus = () => {
  const { user } = useAuth();
  return (
    <>
      {user.balance ? (
        <div className="md:flex gap-2">
          <div className="rounded flex flex-col justify-center p-3 bg-white/5 w-full md:max-w-60">
            <h1 className="text-white/60 text-xl/5 uppercase">Total Balance</h1>
            <span className="text-white/90 text-2xl font-semibold">{formatToTwoDecimalPlaces(user.balance)} $</span>
          </div>
          <div className="rounded flex flex-col w-full p-3 bg-white/5">
            <div className="flex justify-between">
              <div className="text-left">
                <h1 className="text-white/60 text-sm/5 uppercase m-0">Total Balance</h1>
                <span className="text-yellow-500 text-xl font-semibold">{formatToTwoDecimalPlaces(user.balance)} $</span>
              </div>
              <div className="text-right">
                <h1 className="text-white/60 text-sm/5 uppercase m-0">Total Balance</h1>
                <span className="text-green-600 text-xl font-semibold">{formatToTwoDecimalPlaces(user.balance)} $</span>
              </div>
            </div>
            <div className="rounded-lg h-2 w-full bg-green-600"></div>
          </div>
        </div>
      ) : (
        <div className="py-10 text-center text-white/70 text-[12px]">No casino bonus available</div>
      )}
    </>
  );
};
export default CasinoBonus;
